import { useRef } from 'react';
import { type DayProps } from 'react-day-picker';

/**
 * Forwards clicks on the gridcell to its inner button so jsdom-based
 * tests can interact with day cells (jsdom has no layout engine, so
 * the `<td>` doesn't otherwise propagate the click to the `<button>`
 * inside it). Used by every DayPicker we render.
 */
export function ClickableDay({ day: _day, modifiers: _modifiers, ...tdProps }: DayProps) {
  const ref = useRef<HTMLTableCellElement>(null);
  return (
    <td
      ref={ref}
      {...tdProps}
      onClick={(e) => {
        tdProps.onClick?.(e);
        if (!e.defaultPrevented) {
          const btn = ref.current?.querySelector<HTMLButtonElement>('button');
          if (btn && e.target !== btn) btn.click();
        }
      }}
    />
  );
}
